/* src/app/ship/components/import-information/import-information.component.scss */
.customs-tariff {
  text-transform: uppercase;
  position: relative;
}
.customs-tariff + img {
  position: absolute;
  top: 0.4rem;
  right: 0rem;
}
/*# sourceMappingURL=import-information.component.css.map */
